import { format, parse, nextSunday, addDays } from 'date-fns'

export enum DateFormat {
  // 2012-12-24
  ISO_YYYY_MM_DD = 'yyyy-MM-dd',

  // 24/12/2012
  EU_DD_MM_YYYY = 'dd/MM/yyyy',

  // Monday
  DayOfWeek = 'EEEE',

  // 2nd
  DayOfMonth = 'do'
}

export function isDateValid(textValue: string | undefined | null, dateFormat: DateFormat): boolean {
  const newDateValue = textValue ? parse(textValue, dateFormat, new Date()) : undefined
  return newDateValue !== undefined && !isNaN(newDateValue.getDate())
}

export function parseDate(textDate: string, dateFormat: DateFormat): Date | undefined {
  const parsedDate = parse(textDate, dateFormat, new Date())

  return parsedDate && !isNaN(parsedDate.getDate()) ? parsedDate : undefined
}

export function safeFormatDate(date: Date, dateFormat: DateFormat): string | undefined {
  try {
    return formatDate(date, dateFormat)
  } catch (error) {
    return undefined
  }
}

export function formatDate(date: Date, dateFormat: DateFormat): string {
  return format(date, dateFormat)
}

export function formatDayOfWeek(dayIndex: number, dayFormat?: DateFormat) {
  return formatDate(addDays(nextSunday(new Date()), dayIndex), dayFormat || DateFormat.DayOfWeek)
}

export function formatDayOfMonth(dayIndex: number) {
  return formatDate(new Date(2000, 0, dayIndex), DateFormat.DayOfMonth)
}
